import * as Sentry from '@sentry/react';

export const logError = (error, context = {}) => {
  try {
    Sentry.captureException(error, {
      tags: {
        module: context?.module || 'unknown',
      },
      extra: {
        customMessage: context?.customMessage || 'No custom message',
        ...(context?.extra || {}),
      },
    });
  } catch (error) {
    console.error('Could not send error to Sentry', error);
  }
};

// Same helpers as right-impact-app's src/utils/error-logger.ts, so a flow instrumented in both
// clients reads the same in Sentry.
export const addBreadcrumb = (category, message, data) => {
  try {
    Sentry.addBreadcrumb({ category, message, level: 'info', data });
  } catch (error) {
    console.error('Could not add Sentry breadcrumb', error);
  }
};

export const captureMessage = (message, level = 'info', extra) => {
  try {
    Sentry.captureMessage(message, { level, extra });
  } catch (error) {
    console.error('Could not send message to Sentry', error);
  }
};
